var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9121 7.72716C15.7693 7.52759 12.3332 2.84375 7.99998 2.84375C3.6668 2.84375 0.230703 7.52759 0.0878906 7.72719C-0.0292969 7.89016 -0.0292969 8.10987 0.0878906 8.27284C0.230703 8.47241 3.66683 13.1562 7.99998 13.1562C12.3331 13.1562 15.7693 8.47241 15.9121 8.27281C16.0293 8.10984 16.0293 7.89012 15.9121 7.72716ZM7.99998 11.2812C6.19089 11.2812 4.71873 9.80909 4.71873 8C4.71873 6.19091 6.19089 4.71875 7.99998 4.71875C9.80908 4.71875 11.2812 6.19091 11.2812 8C11.2812 9.80909 9.80911 11.2812 7.99998 11.2812Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.59375C7.22456 6.59375 6.59375 7.22456 6.59375 8C6.59375 8.77544 7.22456 9.40625 8 9.40625C8.77544 9.40625 9.40625 8.77544 9.40625 8C9.40628 7.22456 8.77547 6.59375 8 6.59375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.35f83dd772a881a903a4b1057c1f8275.svg";
export { ForwardRef as ReactComponent };